import { useState, useEffect } from "react"
import { PropertyEndpoint } from "../../../api"

function Profile({ userData, handleProfileSubmit, handleProfileChange, profileStatus }) {
    const [role, setRole] = useState("");

    useEffect(() => {
        const propertyEndpoint = new PropertyEndpoint();

        const fetchPropertyData = async () => {
            const response = await propertyEndpoint.getProperties();

            // CARI SEMUA ROLE USER INI DI SEMUA PROPERTY YANG DIA TERDAFTAR
            let roles = [];

            response.forEach(property => {
                property.property_users
                    .filter(pu => pu.user_id === userData.id)
                    .forEach(pu => {
                        roles.push(pu.relation_type);
                    });
            });

            // Hapus duplikasi
            roles = [...new Set(roles)];

            // Kapitalisasi + gabungkan
            const formatted =
                roles
                    .map(r => r.charAt(0).toUpperCase() + r.slice(1))   // owner → Owner
                    .join(" and ");

            setRole(formatted);

            console.log("User Roles:", formatted);
        };

        fetchPropertyData();
    });
    return (
        <div >
            <div className="ltn__myaccount-tab-content-inner">
                <h4>Profile Information</h4>
                <p>Update your personal information associated with your account.</p>

                <div className="row mb-30">
                    <div className="col-md-3 text-center">
                        {userData.profile_photo ? (
                            <img
                                src={userData.profile_photo}
                                alt={userData.name}
                                className="img-fluid rounded-circle"
                            />
                        ) : (
                            <div className="img-fluid rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 80, height: 80 }}>
                                <span>{userData.name ? userData.name.charAt(0) : "U"}</span>
                            </div>
                        )}
                    </div>
                    <div className="col-md-9 d-flex align-items-center">
                        <div>
                            <h6>{userData.name}</h6>
                            <p className="mb-0">{userData.email}</p>
                            <p className="mb-0">Role: {role}</p>
                            <p className="mb-0">{userData.phone_number}</p>
                        </div>
                    </div>
                </div>

                <div className="ltn__form-box">
                    <form onSubmit={handleProfileSubmit}>
                        <div className="row mb-50">
                            <div className="col-md-6">
                                <label>Full Name:</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={userData.name}
                                    onChange={handleProfileChange}
                                />
                            </div>
                            <div className="col-md-6">
                                <label>Email:</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={userData.email}
                                    onChange={handleProfileChange}
                                />
                            </div>
                            <div className="col-md-6">
                                <label>Phone Number:</label>
                                <input
                                    type="text"
                                    name="phone_number"
                                    value={userData.phone_number}
                                    onChange={handleProfileChange}
                                />
                            </div>
                            <div className="col-md-6">
                                <label>Address:</label>
                                <input
                                    type="text"
                                    name="address"
                                    value={userData.address}
                                    onChange={handleProfileChange}
                                />
                            </div>
                        </div>
                        {profileStatus.message && (
                            <div
                                className={`mt-2 mb-3 ${profileStatus.type === "success"
                                    ? "text-success"
                                    : profileStatus.type === "info"
                                        ? "text-info"
                                        : "text-danger"
                                    }`}
                                style={{
                                    color:
                                        profileStatus.type === "success"
                                            ? "green"
                                            : profileStatus.type === "info"
                                                ? "blue"
                                                : "red",
                                }}
                            >
                                {profileStatus.message}
                            </div>
                        )}
                        <div className="btn-wrapper">
                            <button type="submit" className="btn theme-btn-1 btn-effect-1 text-uppercase">
                                Save Changes
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Profile